import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  Divider,
  Chip,
  CircularProgress
} from '@mui/material';
import { Shield } from 'lucide-react';

export default function PrivacyPolicyPage() {
  const theme = useTheme();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/content/privacy_policy_contents.html')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load privacy policy content');
        }
        return response.text();
      })
      .then(html => {
        setContent(html);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading privacy policy:', err);
        setError('Failed to load privacy policy content. Please try again later.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom right, #fef2f2, #fdf2f8)'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom right, #fef2f2, #fdf2f8)'
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom right, #fef2f2, #fdf2f8)',
        py: 2
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        {/* <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Chip
            icon={<Shield className="w-4 h-4" />}
            label="Privacy Policy"
            sx={{
              bgcolor: theme.palette.primary.main,
              color: 'white',
              fontSize: '1rem',
              py: 2,
              px: 2,
              mb: 2
            }}
          />
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
            Your Privacy Matters
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Box> */}

        {/* Content */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            bgcolor: 'background.paper',
            borderRadius: 4
          }}
        >
          <Box
            sx={{
              '& h2': {
                color: theme.palette.primary.main,
                fontSize: '1.5rem',
                fontWeight: 600,
                mt: 4,
                mb: 2
              },
              '& h3': {
                fontSize: '1.25rem',
                fontWeight: 600,
                mt: 3,
                mb: 2
              },
              '& p': {
                mb: 2,
                lineHeight: 1.7
              },
              '& ul': {
                mb: 2,
                pl: 2
              },
              '& li': {
                mb: 1,
                lineHeight: 1.7
              }
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Paper>

        {/* Footer */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body2" color="text.secondary">
            If you have any questions about our privacy policy, please contact us at{' '}
            <Box
              component="a"
              href="mailto:privacy@bean.com"
              sx={{
                color: theme.palette.primary.main,
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              privacy@bean.com
            </Box>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
